import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Subject, tap } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { checkToken } from './interceptor.service';

@Injectable({
  providedIn: 'root'
})
export class FreeCompaniesService {
  private urlProd: string = environment.apiRoot;
  private _refresrequired = new Subject<void>();
  private hasChangesSubject = new BehaviorSubject<boolean>(false);
  public hasChanges$ = this.hasChangesSubject.asObservable();

  private actionSource = new Subject<void>();
  action$ = this.actionSource.asObservable();

  constructor(private http: HttpClient) {}

  get Refreshrequired() {
    return this._refresrequired;
  }

  triggerAction(): void {
    this.actionSource.next();
  }

  setChanges(hasChanges: boolean): void {
    this.hasChangesSubject.next(hasChanges);
  }

  listAllCompanies(page: number, limit: number, sortField: string, sortDirection: string, searchValue?: string, searchTerm: string = "name") {
    let baseUrl = new URL(`${this.urlProd}company-auth/get-all-companies?page=${page}&limit=${limit}`);

    let searchParams = baseUrl.searchParams;
    if (sortField) {
      searchParams.set('sortField', sortField);
    }

    if (sortDirection) {
      searchParams.set('sortDirection', sortDirection);
    }

    if (searchTerm && searchValue) {
      searchParams.set('searchTerm', searchTerm);
      searchParams.set('searchValue', searchValue);
    }

    return this.http.get(
      baseUrl.toString(),
      { context: checkToken() }
    );
  }

  listFreeCompanies(page: number, limit: number, sortField: string, sortDirection: string, searchValue?: string, searchTerm: string = "name") {
    let baseUrl = new URL(`${this.urlProd}company-auth/get-free-companies?page=${page}&limit=${limit}`);
    let searchParams = baseUrl.searchParams;
    if (sortField) {
      searchParams.set('sortField', sortField);
    }

    if (sortDirection) {
      searchParams.set('sortDirection', sortDirection);
    }

    if (searchTerm && searchValue) {
      searchParams.set('searchTerm', searchTerm);
      searchParams.set('searchValue', searchValue);
    }

    return this.http.get(
      baseUrl.toString(),
      { context: checkToken() }
    );
  }

  updateAnyCompany(body: any) {
    return this.http.put(
      `${this.urlProd}company-auth/admin-update-company`,
      body,
      { context: checkToken() }
    );
  }

  disabledCompany(company_id: string) {
    return this.http.put(
      `${this.urlProd}company-auth/disable-admin-company?company_id=${company_id}`,
      null, // El cuerpo se elimina, así que lo pasamos como `null`
      { context: checkToken() }
    );
  }

  updateAllCompanies(companies: any[]) {
    return this.http.put(
      `${this.urlProd}company-auth/admin-update-all-company`,
      companies,
      { context: checkToken() }
    );
  }

  listFreeAllied() {
    return this.http.get(
      `${this.urlProd}allied/free-list-allied`,
      { context: checkToken() }
    );
  }

  listFreeGroups() {
    return this.http.get(
      `${this.urlProd}groups-companies/free-list-group`,
      { context: checkToken() }
    );
  }

  listAgencies() {
    return this.http.get(
      `${this.urlProd}groups-companies/list-agencies`,
      { context: checkToken() }
    );
  }

  listFreeFacilitator() {
    return this.http.get(
      `${this.urlProd}facilitator/free-list-facilitator`,
      { context: checkToken() }
    );
  }

  listFacilitatorByAllied(id_allied: string) {
    return this.http.get(
      `${this.urlProd}facilitator/facilitator-by-allied?id_allied=${id_allied}`,
      { context: checkToken() }
    );
  }

  listGroupsByAllied(id_allied: string) {
    return this.http.get(
      `${this.urlProd}groups-companies/groups-by-allied?id_allied=${id_allied}`,
      { context: checkToken() }
    );
  }

}
